import "../stylesheets/paymentsPageStyles.css";
import { useSelector } from "react-redux";
import { Button } from "semantic-ui-react";
import { ibmRelatedSvg, skillsListData, tickIcons } from "./constants";
import { USER_THEME } from "../../constants";
import { ADDONS_ACTIONS, ADDONS_TYPES } from "../constants";

export default function IbmAddOnService({
  ibmContentDetails,
  isIbmAddOnAdded,
  addRemoveAddOns,
  isIbmAddOnButtonLoading,
  courseSlug,
}) {
  const { theme } = useSelector((state) => state);

  return (
    <div className="ibmAddOnService">
      <div className="ibmAddOnTop">
        <div className="heading">Certification Exam</div>
        <div className="description">
          <span>Powered by: </span>
          <span>
            {theme === USER_THEME.LIGHT
              ? ibmRelatedSvg?.ibmLogo
              : ibmRelatedSvg?.ibmLogoBlack}
          </span>
        </div>
      </div>
      <div className="ibmAddOnBottom">
        <ul className="listContainer">
          {skillsListData?.map((data, index) => {
            return (
              <li key={index}>
                <img
                  src={
                    theme === USER_THEME.LIGHT
                      ? tickIcons.light
                      : tickIcons.dark
                  }
                  alt="tick icon"
                />
                <span>{data}</span>
              </li>
            );
          })}
        </ul>
        <div>
          <div className="price">
            {ibmContentDetails?.external_certification_fee_str}
          </div>
          <Button
            className="addRemoveButton"
            loading={isIbmAddOnButtonLoading}
            content={!isIbmAddOnAdded ? "Add" : "Remove"}
            onClick={() => {
              addRemoveAddOns(
                isIbmAddOnAdded
                  ? {
                      action: ADDONS_ACTIONS.REMOVE_FROM_CART,
                      type: ADDONS_TYPES.EXTERNAL_CERTIFICATION,
                    }
                  : {
                      action: ADDONS_ACTIONS.ADD_TO_CART,
                      type: ADDONS_TYPES.EXTERNAL_CERTIFICATION,
                    }
              );
              if (sessionStorage.getItem(`ibm_cert_${courseSlug}`))
                sessionStorage.removeItem(`ibm_cert_${courseSlug}`);
              else sessionStorage.setItem(`ibm_cert_${courseSlug}`, true);
            }}
          />
        </div>
      </div>
    </div>
  );
}
